import Vue from 'vue';
import themeProduct from './singleproduct.vue';
Vue.component('singleProduct',themeProduct);